import { FieldReviewTable } from '../fieldReviewTable';

export interface VerificationOfMortgageReviewTableProps {
  data: Record<string, any>;
}

export const VerificationOfMortgageReviewTable = ({ data }: VerificationOfMortgageReviewTableProps) => {
  return <FieldReviewTable items={data?.items} />;
};
